import { DefaultTheme } from 'styled-components'

export const tooltipIds = {
  // primary: {},
  secondary: {
    universal: 'universal',
    altitudeSuggested: 'routePanel-altitudeSuggested'
  },
  info: {
    universal: 'info-universal'
  },
  /**
   * Pílula usada nos botões de ícone do Drawer e da Toolbar. `active` é a variação para o botão da
   * opção/ferramenta que está aberta (fundo e texto verdes).
   */
  pill: {
    universal: 'pill-universal',
    active: 'pill-active'
  }
  // withArrow: {}
}

export const tooltipContentsWithIcons = (theme: DefaultTheme) => ({
  [tooltipIds.secondary.altitudeSuggested]: {
    icon: 'AI',
    color: theme.colors.yellowL0
  }
})

/**
 * Origem da informação de cada campo, usada para escolher a pílula da tooltip de apoio.
 * - `ficha`: vem da ficha de pesagem da aeronave
 * - `manual`: vem do manual do avião
 * - `ajuste`: é uma escolha do usuário no cadastro
 */
export type InfoTooltipType = 'ficha' | 'manual' | 'ajuste'

/**
 * Cores definidas no briefing de conteúdo (docs/Copy_i_Peso_Balanceamento_FINAL_1.html).
 * Não existem no tema do @nexds/web, por isso ficam hardcoded aqui.
 */
export const infoTooltipPills: Record<InfoTooltipType, { label: string; background: string; labelColor: string }> = {
  ficha: { label: 'Ficha', background: '#FFCE4D', labelColor: '#3A2B00' },
  manual: { label: 'Manual', background: '#14B8A3', labelColor: '#04231F' },
  ajuste: { label: 'Ajuste', background: '#7FB0E0', labelColor: '#0A2033' }
}

/** Atributos lidos do elemento âncora pela tooltip de apoio. */
export const infoTooltipAttrs = {
  title: 'data-info-title',
  type: 'data-info-type',
  description: 'data-info-description'
} as const
